import { cn } from "@/libs/utils";

export const OpenerIcon = ({ className }: { className?: string }) => (
  <svg
    className={cn("size-10", className)}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.8" cx="20" cy="20" r="20" fill="#343A3F" />
    <mask
      id="mask0_19604_34105"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="16"
      height="16"
    >
      <rect x="12" y="12" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_19604_34105)">
      <path
        d="M20.0005 25.6673C19.8587 25.6673 19.74 25.6194 19.6443 25.5235C19.5485 25.4277 19.5007 25.309 19.5007 25.1673V20.5007H14.834C14.6923 20.5007 14.5736 20.4527 14.4778 20.3568C14.3819 20.2609 14.334 20.1422 14.334 20.0005C14.334 19.8587 14.3819 19.74 14.4778 19.6443C14.5736 19.5485 14.6923 19.5007 14.834 19.5007H19.5007V14.834C19.5007 14.6923 19.5486 14.5736 19.6445 14.4778C19.7404 14.3819 19.8592 14.334 20.0008 14.334C20.1426 14.334 20.2613 14.3819 20.357 14.4778C20.4528 14.5736 20.5007 14.6923 20.5007 14.834V19.5007H25.1673C25.309 19.5007 25.4277 19.5486 25.5235 19.6445C25.6194 19.7404 25.6673 19.8592 25.6673 20.0008C25.6673 20.1426 25.6194 20.2613 25.5235 20.357C25.4277 20.4528 25.309 20.5007 25.1673 20.5007H20.5007V25.1673C20.5007 25.309 20.4527 25.4277 20.3568 25.5235C20.2609 25.6194 20.1422 25.6673 20.0005 25.6673Z"
        fill="white"
      />
    </g>
  </svg>
);
